import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
export const InputCell = _ref => {
  let {
    value,
    onBlur,
    disabled = false,
    as,
    fieldName = '',
    body = {}
  } = _ref;
  const [internalValue, setInternalValue] = useState(value);
  useEffect(() => {
    setInternalValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(Form.Control, {
    as: as,
    onChange: e => setInternalValue(e.target.value),
    onBlur: () => onBlur(fieldName, internalValue, body),
    value: internalValue,
    disabled: disabled,
    name: fieldName,
    type: "text",
    size: "sm"
  });
};